import { useCallback } from 'react';

export const useSpeechSynthesis = () => {
  const speak = useCallback((text, options = {}) => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = options.rate || 0.9;
      utterance.pitch = options.pitch || 1;
      utterance.volume = options.volume || 1;
      utterance.lang = options.lang || 'en-US';
      window.speechSynthesis.speak(utterance);
    }
  }, []);

  const speakBilingual = useCallback((englishText, teluguText) => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const englishUtterance = new SpeechSynthesisUtterance(englishText);
      englishUtterance.rate = 0.9;
      englishUtterance.pitch = 1;
      englishUtterance.volume = 1;
      englishUtterance.lang = 'en-IN';
      
      englishUtterance.onend = () => {
        const teluguUtterance = new SpeechSynthesisUtterance(teluguText);
        teluguUtterance.rate = 0.85;
        teluguUtterance.pitch = 1;
        teluguUtterance.volume = 1;
        teluguUtterance.lang = 'te-IN';
        window.speechSynthesis.speak(teluguUtterance);
      };
      window.speechSynthesis.speak(englishUtterance);
    }
  }, []);

  const speakWithGenderVoices = useCallback((text) => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      
      const voices = window.speechSynthesis.getVoices();
      const maleVoice = voices.find(v => v.lang.includes('en') && v.name.toLowerCase().includes('male')) 
                     || voices.find(v => v.lang.includes('en-IN'))
                     || voices.find(v => v.lang.includes('en'));
      const femaleVoice = voices.find(v => v.lang.includes('en') && v.name.toLowerCase().includes('female'))
                       || voices.find(v => v.lang.includes('en-IN'))
                       || voices.find(v => v.lang.includes('en'));

      // First: Male voice
      const maleUtterance = new SpeechSynthesisUtterance(text);
      maleUtterance.voice = maleVoice;
      maleUtterance.rate = 0.9;
      maleUtterance.pitch = 0.9;
      maleUtterance.volume = 1;
      maleUtterance.lang = 'en-IN';

      maleUtterance.onend = () => {
        // Second: Female voice
        const femaleUtterance = new SpeechSynthesisUtterance(text);
        femaleUtterance.voice = femaleVoice;
        femaleUtterance.rate = 0.9;
        femaleUtterance.pitch = 1.1;
        femaleUtterance.volume = 1;
        femaleUtterance.lang = 'en-IN';
        window.speechSynthesis.speak(femaleUtterance);
      };

      window.speechSynthesis.speak(maleUtterance);
    }
  }, []);

  const cancel = useCallback(() => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }
  }, []);

  return { speak, speakBilingual, speakWithGenderVoices, cancel };
};

export default useSpeechSynthesis;